module.exports = __webpack_public_path__ + "static/img/addrestaurant.83160bb.png";